import type { Ctx } from "../../types";
import { Action, invalidate } from "gg-wf-scripts";
import { toast } from "../../toast";

export const update_pay_status: Action<
  Ctx,
  { id?: string; pay_status?: string }
> = async ({ sb }, data, params, helpers) => {
  const job_opening_id = data.id ?? params.get("id");
  if (!job_opening_id) {
    return { ok: false, error: "Missing id on row record or in URL" };
  }
  if (!data.pay_status) {
    return { ok: false, error: "Missing pay_status in action data" };
  }

  const { data: updated, error } = await sb
    .from("job_openings")
    .update({ pay_status: data.pay_status })
    .eq("id", job_opening_id)
    .is("deleted_at", null)
    .select("id")
    .maybeSingle();
  if (error) {
    toast({ variant: "error", text: "Pay update failed. Try again" });
    return { ok: false, error: error.message };
  }
  if (!updated) {
    toast({ variant: "warning", text: "Job not found." });
    return { ok: false, error: "Job not found" };
  }
  helpers.removeItem((r) => r.id === job_opening_id);
  invalidate("jobs");
  toast({ variant: "success", text: "Pay status updated!" });
  return { ok: true };
};
